/*
 * Don Castor: módulo de filtros de colección en panel flotante. Lo carga sections/main-collection-product-grid.liquid.
 * Parte de dc-ui.js separada para no cargarla en las páginas que no la usan.
 */
(function () {
  'use strict';
  /* Una sola inicialización aunque el script se inserte varias veces (vista rápida de Dawn) */
  if (window.__dcFilters) return;
  window.__dcFilters = true;

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function store(kind, key, value) {
    try {
      var s = window[kind];
      if (value === undefined) return s.getItem(key);
      if (value === null) s.removeItem(key); else s.setItem(key, value);
    } catch (e) { return null; }
  }

  /* --- Colección: filtros en panel flotante (sobrevive a los re-render de facets.js) --- */
  /* Panel flotante a la izquierda (≥ 750 px). Siempre empieza cerrado: abierto taparía la página.
     Se cierra con la X, con clic en el fondo o con Esc; el foco vuelve al botón «Filtros». */
  var filtersToggleLast = null;
  function applyFilters(open) {
    $$('[data-dc-filters-layout]').forEach(function (layout) { layout.classList.toggle('is-collapsed', !open); });
    $$('[data-dc-filters-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = $('[data-dc-filters-label]', btn);
      if (label) label.textContent = open ? btn.dataset.labelHide : btn.dataset.labelShow;
    });
    root.classList.toggle('dc-filters-lock', open);
    var panel = $('#main-collection-filters');
    if (open && panel) {
      var close = $('.dc-filters-close', panel);
      window.setTimeout(function () { (close || panel).focus(); }, 60);
    } else if (!open && filtersToggleLast) {
      filtersToggleLast.focus();
      filtersToggleLast = null;
    }
  }
  if ($('[data-dc-filters-layout]')) applyFilters(false);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dc-filters-toggle]');
    if (btn) {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      if (open) filtersToggleLast = btn;
      applyFilters(open);
      return;
    }
    if (e.target.closest('[data-dc-filters-close]')) applyFilters(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('dc-filters-lock')) applyFilters(false);
  });

})();
